import { injectable } from 'inversify';
import type { BlobInfo } from '../CaseDataProvider';

@injectable()
export class PackageInfoStore {
  private _mapBlobDescriptor2BlobInfo: Map<string, BlobInfo> = new Map();

  private _mapBlobDescriptor2Blob = new Map<string, Promise<ArrayBuffer>>();

  public addBlobInfo(descriptor: string, blobInfo: BlobInfo): void {
    this._mapBlobDescriptor2BlobInfo.set(descriptor, blobInfo);
  }

  public getBlobInfo(descriptor: string): BlobInfo | undefined {
    return this._mapBlobDescriptor2BlobInfo.get(descriptor);
  }

  public addBlob(descriptor: string, blob: Promise<ArrayBuffer>): void {
    this._mapBlobDescriptor2Blob.set(descriptor, blob);
  }

  public getBlob(descriptor: string): Promise<ArrayBuffer> | undefined {
    return this._mapBlobDescriptor2Blob.get(descriptor);
  }
}
